export enum HttpErrorCodes {
  'BAD_REQUEST' = 400,
  'FORBIDDEN' = 403,
  'NOT_FOUND' = 404,
  'CONFLICT' = 409,
  'INTERNAL_SERVER_ERROR' = 500,
  'BAD_GATEWAY' = 502,
}

export const ERROR_CLASS_500 = [
  HttpErrorCodes.INTERNAL_SERVER_ERROR,
  HttpErrorCodes.BAD_GATEWAY,
];
